import React, { useState } from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import Player from "../../../../organisms/Player";
import classes from "./WritingCompetitionIntro.module.scss";

const WritingCompetitionIntro = ({
  writingCompetitionData,
  authorization,
  history,
  isMobile,
  stage,
  stageColors,
  playIcon,
  APPLICATION_ROUTES,
  BUTTON_STATUS,
  onScrollToVideoSection,
  fullWidth,
}) => {
  console.log("WritingCompetitionIntro: data", writingCompetitionData);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayVideo = () => {
    setIsPlaying(true);
  };

  return (
    <div className={cs(classes.videoSection, fullWidth && classes.fullWidth)}>
      {writingCompetitionData?.details?.stage === stage.AWARD_SHOW ? (
        <>
          {writingCompetitionData?.details?.intro_video ? (
            <div
              className={cs(
                classes.videoContainer,
                fullWidth && classes.fullWidth
              )}
              style={{
                backgroundColor:
                  stageColors[writingCompetitionData?.details?.stage],
              }}
            >
              {!isPlaying ? (
                <div
                  className={cs(classes.videoContent)}
                  style={{
                    backgroundImage: `url(${writingCompetitionData?.details?.intro_video_thumbnail})`,
                  }}
                >
                  <button
                    className={cs(classes.playButton)}
                    onClick={handlePlayVideo}
                  >
                    <img src={playIcon} alt="Play Icon" />
                  </button>
                </div>
              ) : (
                <Player
                  video={writingCompetitionData?.details?.intro_video}
                  autoplay
                  additionalClass={isMobile ? "mobileHeight" : "desktopHeight"}
                  muted={isMobile ? true : false}
                  playerSize="regularPlayer"
                  page="writingCompetition"
                  disableForward={true}
                />
              )}
            </div>
          ) : (
            <div
              className={cs(
                classes.videoContainer,
                fullWidth && classes.fullWidth
              )}
              style={{
                backgroundColor:
                  stageColors[writingCompetitionData?.details?.stage],
              }}
            >
              <img
                src={writingCompetitionData?.details?.intro_image}
                alt="img"
              />
            </div>
          )}
        </>
      ) : (
        <div
          className={cs(
            classes.videoContainer,
            fullWidth && classes.fullWidth
          )}
          style={{
            backgroundColor:
              stageColors[writingCompetitionData?.details?.stage],
          }}
        >
          {!isPlaying ? (
            <div
              className={cs(classes.videoContent)}
              style={{
                backgroundImage: `url(${writingCompetitionData?.details?.intro_video_thumbnail})`,
              }}
            >
              <button
                className={cs(classes.playButton)}
                onClick={handlePlayVideo}
              >
                <img src={playIcon} alt="Play Icon" />
              </button>
            </div>
          ) : (
            <Player
              video={writingCompetitionData?.details?.intro_video}
              autoplay
              additionalClass={isMobile ? "mobileHeight" : "desktopHeight"}
              muted={isMobile ? true : false}
              playerSize="regularPlayer"
              page="writingCompetition"
              disableForward={true}
            />
          )}
        </div>
      )}
      <div className={cs(classes.videoInfo, fullWidth && classes.fullWidth)}>
        <div className={cs(classes.videoText)}>
          <h1 className={cs(classes.grandstanderFamily)}>
            {writingCompetitionData?.details?.text}
          </h1>
          <p className={cs(classes.videoDescription)}>
            {writingCompetitionData?.details?.description}
          </p>
        </div>
        {writingCompetitionData?.details?.stage === "Character Building" && (
          <>
            {writingCompetitionData?.status === BUTTON_STATUS.SUBMITTED ? (
              <>
                <p>
                  {writingCompetitionData?.character_submission_status ===
                  BUTTON_STATUS.ACCEPTED ? (
                    <button
                      className={cs(
                        classes.statusDescription,
                        classes.acceptedButton
                      )}
                    >
                      Your submission has <br /> been accepted
                    </button>
                  ) : writingCompetitionData?.character_submission_status ===
                    BUTTON_STATUS.REJECTED ? (
                    <button
                      className={cs(
                        classes.statusDescription,
                        classes.declinedButton
                      )}
                    >
                      Your submission was declined.
                      <span>Check your email for more details.</span>
                    </button>
                  ) : (
                    <button
                      className={cs(
                        classes.statusDescription,
                        classes.inReviewButton
                      )}
                    >
                      Your submission <br /> is in review
                    </button>
                  )}
                </p>
              </>
            ) : (
              <button
                onClick={() => {
                  if (authorization.isAuthenticated) {
                    history.push(APPLICATION_ROUTES.WRITINNG_COMPETITION_FORM);
                  } else {
                    history.push(
                      `${APPLICATION_ROUTES.SIGN_IN}?redirect=${APPLICATION_ROUTES.WRITINNG_COMPETITION}`
                    );
                  }
                }}
                className={cs(classes.joinButton, classes.grandstanderFamily)}
              >
                {!authorization.isAuthenticated ? (
                  "Login To Submit"
                ) : (
                  <>
                    {writingCompetitionData?.status === "pending"
                      ? "Finish Your Draft"
                      : writingCompetitionData?.details?.button}
                  </>
                )}
              </button>
            )}
          </>
        )}
        {writingCompetitionData?.details?.stage === "Script Submission" && (
          <>
            {authorization.isAuthenticated ? (
              <>
                {!writingCompetitionData?.character_submission_status ? (
                  <p className={cs(classes.statusDescriptionNew)}>
                    While Stage 2 has already begun, you can still join the
                    contest, you must complete the requirements for both Stage 1
                    and Stage 2 by כ&quot;ו אדר (3/15/26).
                    <span>
                      {" "}
                      <a
                        href={`${APPLICATION_ROUTES.WRITINNG_COMPETITION_FORM}?eJwBMADP=1`}
                      >
                        Click here
                      </a>{" "}
                      to start Stage 1.{" "}
                    </span>
                  </p>
                ) : (
                  <>
                    {writingCompetitionData?.character_submission_status ===
                    BUTTON_STATUS.ACCEPTED ? (
                      <>
                        {writingCompetitionData?.video_submission_status &&
                        writingCompetitionData?.status === "submitted" ? (
                          <>
                            {writingCompetitionData?.video_submission_status ===
                              BUTTON_STATUS.SUBMITTED && (
                              <p
                                className={cs(
                                  classes.statusDescription,
                                  classes.inReviewButton
                                )}
                              >
                                Your submission <br /> is in review
                              </p>
                            )}
                            {writingCompetitionData?.video_submission_status ===
                              BUTTON_STATUS.ACCEPTED && (
                              <p
                                className={cs(
                                  classes.statusDescription,
                                  classes.acceptedButton
                                )}
                              >
                                Your submission has <br /> been accepted
                              </p>
                            )}
                            {writingCompetitionData?.video_submission_status ===
                              BUTTON_STATUS.REJECTED && (
                              <p
                                className={cs(
                                  classes.statusDescription,
                                  classes.declinedButton
                                )}
                              >
                                Your submission was declined.
                                <span>Check your email for more details.</span>
                              </p>
                            )}
                          </>
                        ) : (
                          <button
                            onClick={() => {
                              if (authorization.isAuthenticated) {
                                history.push(
                                  APPLICATION_ROUTES.WRITING_COMPETITON_VIDEO_FORM
                                );
                              } else {
                                history.push(
                                  `${APPLICATION_ROUTES.SIGN_IN}?redirect=${APPLICATION_ROUTES.WRITINNG_COMPETITION}`
                                );
                              }
                            }}
                            className={cs(
                              classes.joinButton,
                              classes.grandstanderFamily
                            )}
                          >
                            {!authorization.isAuthenticated ? (
                              "Login To Submit"
                            ) : (
                              <>{writingCompetitionData?.details?.button}</>
                            )}
                          </button>
                        )}
                      </>
                    ) : (
                      <p
                        className={cs(
                          classes.statusDescription,
                          writingCompetitionData?.character_submission_status ===
                            BUTTON_STATUS.REJECTED
                            ? classes.declinedButton
                            : classes.inReviewButton
                        )}
                      >
                        {writingCompetitionData?.character_submission_status ===
                        BUTTON_STATUS.REJECTED
                          ? "Your story outline was not accepted."
                          : " Your submission \n is in review."}
                      </p>
                    )}
                  </>
                )}
              </>
            ) : (
              <button
                onClick={() => {
                  if (authorization.isAuthenticated) {
                    history.push(
                      APPLICATION_ROUTES.WRITING_COMPETITON_VIDEO_FORM
                    );
                  } else {
                    history.push(
                      `${APPLICATION_ROUTES.SIGN_IN}?redirect=${APPLICATION_ROUTES.WRITINNG_COMPETITION}`
                    );
                  }
                }}
                className={cs(classes.joinButton, classes.grandstanderFamily)}
              >
                {!authorization.isAuthenticated ? (
                  "Login To Submit"
                ) : (
                  <>{writingCompetitionData?.details?.button}</>
                )}
              </button>
            )}
          </>
        )}

        {writingCompetitionData?.details?.stage === "Voting" && (
          <button
            onClick={() => {
              if (authorization.isAuthenticated) {
                onScrollToVideoSection && onScrollToVideoSection();
              } else {
                history.push(
                  `${APPLICATION_ROUTES.SIGN_IN}?redirect=${APPLICATION_ROUTES.WRITINNG_COMPETITION}`
                );
              }
            }}
            className={cs(
              classes.joinButton,
              classes.grandstanderFamily,
              writingCompetitionData?.stages?.Voting?.judges_in_session &&
                classes.blueColor
            )}
          >
            {!authorization.isAuthenticated ? (
              "Login To Vote"
            ) : (
              <>{writingCompetitionData?.details?.button}</>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

WritingCompetitionIntro.propTypes = {
  writingCompetitionData: PropTypes.shape({
    details: PropTypes.shape({
      stage: PropTypes.string,
      intro_video: PropTypes.string,
      intro_video_thumbnail: PropTypes.string,
      intro_image: PropTypes.string,
      text: PropTypes.string,
      description: PropTypes.string,
      button: PropTypes.string,
    }),
    status: PropTypes.string,
    character_submission_status: PropTypes.string,
    video_submission_status: PropTypes.string,
    stages: PropTypes.shape({
      Voting: PropTypes.shape({
        judges_in_session: PropTypes.bool,
      }),
    }),
  }),
  authorization: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  isMobile: PropTypes.bool,
  stage: PropTypes.objectOf(PropTypes.string),
  stageColors: PropTypes.objectOf(PropTypes.string),
  playIcon: PropTypes.string,
  APPLICATION_ROUTES: PropTypes.objectOf(PropTypes.string),
  BUTTON_STATUS: PropTypes.objectOf(PropTypes.string),
  onScrollToVideoSection: PropTypes.func,
  fullWidth: PropTypes.bool,
};


export default WritingCompetitionIntro;

